import { useState } from "react";
import { AuthShell } from "@/pages/Login";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";

export default function ForgotPassword() {
  const nav = useNavigate();
  const [stage, setStage] = useState(1);
  const [form, setForm] = useState({ email: "", code: "", new_password: "" });
  const [loading, setLoading] = useState(false);

  const sendCode = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await api.post("/auth/forgot", { email: form.email }); toast.success("Code sent — check your inbox"); setStage(2); }
    catch { toast.error("Could not send code"); }
    finally { setLoading(false); }
  };
  const reset = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset", form);
      toast.success("Password reset — log in now");
      nav("/login");
    } catch (err) { toast.error(err.response?.data?.detail || "Reset failed"); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell title={stage === 1 ? "Forgot password?" : "Enter your new password"} subtitle={stage === 1 ? "We'll email a reset code." : `Code sent to ${form.email}`}>
      {stage === 1 ? (
        <form onSubmit={sendCode} className="space-y-4">
          <div>
            <label className="text-xs font-medium text-slate-600 uppercase tracking-wider">Email</label>
            <Input data-testid="forgot-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1.5" />
          </div>
          <Button data-testid="forgot-submit" disabled={loading} className="btn-orange hover:bg-[#FF6A00] w-full py-6">{loading ? "Sending..." : "Send code"}</Button>
          <div className="text-sm text-center"><Link to="/login" className="text-slate-500">Back to login</Link></div>
        </form>
      ) : (
        <form onSubmit={reset} className="space-y-4">
          <div>
            <label className="text-xs font-medium text-slate-600 uppercase tracking-wider">Reset code</label>
            <Input data-testid="reset-code" required value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value })} className="mt-1.5" />
          </div>
          <div>
            <label className="text-xs font-medium text-slate-600 uppercase tracking-wider">New password</label>
            <Input data-testid="reset-password" type="password" required minLength={6} value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} className="mt-1.5" />
          </div>
          <Button data-testid="reset-submit" disabled={loading} className="btn-orange hover:bg-[#FF6A00] w-full py-6">{loading ? "Resetting..." : "Reset password"}</Button>
        </form>
      )}
    </AuthShell>
  );
}
